module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921081149_T.821a5268.jpg";